import React from 'react';
import { Icons } from '../icons/icons';

type Props = {
  children: string;
};

export const ErrorMessage = (props: Props): JSX.Element => {
  return (
    <span className="gray-1 form-error-message d-flex align-items-center">
      <Icons.Error />
      <span>{props.children}</span>
    </span>
  );
};
